import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/authService";
import { toast } from "react-toastify";

const ChangePassword = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let newErrors = {};

        if (!form.newPassword) {
            newErrors.newPassword = "New password is required";
        } else if (form.newPassword.length < 6) {
            newErrors.newPassword = "Password must be at least 6 characters";
        }

        if (!form.confirmPassword) {
            newErrors.confirmPassword = "Confirm password is required";
        } else if (form.newPassword !== form.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        try {
            const payload = {
                password: form.newPassword,
                password_confirmation: form.confirmPassword,
            };

            const res = await changePassword(payload);

            if (res.status === "success") {
                toast.success(res.message || "Password Changed successfully!");

                setForm({
                    newPassword: "",
                    confirmPassword: "",
                });
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message || "Something went wrong");
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.container}>

                {/* 🔙 BACK BUTTON */}
                <div style={styles.header}>
                    <span style={styles.backBtn} onClick={() => navigate(-1)}>
                        ← Back
                    </span>
                </div>

                <h2 style={{ textAlign: "center" }}>Change Password</h2>

                <form onSubmit={handleSubmit} style={styles.form}>

                    <div>
                        <input
                            type="password"
                            name="newPassword"
                            placeholder="New Password"
                            value={form.newPassword}
                            onChange={handleChange}
                            style={styles.input}
                        />
                        {errors.newPassword && (
                            <span style={styles.error}>{errors.newPassword}</span>
                        )}
                    </div>

                    <div>
                        <input
                            type="password"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={form.confirmPassword}
                            onChange={handleChange}
                            style={styles.input}
                        />
                        {errors.confirmPassword && (
                            <span style={styles.error}>{errors.confirmPassword}</span>
                        )}
                    </div>

                    <button type="submit" style={styles.button}>
                        Update Password
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
    },

    container: {
        background: "#fff",
        padding: "30px",
        borderRadius: "8px",
        width: "100%",
        maxWidth: "400px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },

    header: {
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: "10px"
    },

    backBtn: {
        cursor: "pointer",
        color: "#007bff",
        fontSize: "14px",
        fontWeight: "500"
    },

    form: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    },

    input: {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
    },

    button: {
        background: "#007bff",
        color: "#fff",
        padding: "10px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },

    error: {
        color: "red",
        fontSize: "12px",
        marginTop: "5px",
        display: "block",
    },
};

export default ChangePassword;